import { render, staticRenderFns } from "./ArchivePaymentsModal.vue?vue&type=template&id=fa86444c&"
import script from "./ArchivePaymentsModal.vue?vue&type=script&lang=js&"
export * from "./ArchivePaymentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchivePaymentsModal.vue"
export default component.exports